import { apiClient } from "./apiClient";
import { API_BASE_URL } from "../config";

// Ofis CCTV: yetkili kamera listesi + HLS playlist URL üretimi.
// Stream URL'leri same-origin /api/cctv/stream/... altındadır; auth cookie
// otomatik gönderilir ve her segment isteği backend'de izin kontrolünden geçer.
export const cctvService = {
  listCameras: () => apiClient.get("/cctv/cameras").then((r) => r.data?.cameras || []),

  // streamId -> HLS playlist URL'i (örn. ofis102 -> /api/cctv/stream/ofis102/index.m3u8)
  streamUrl: (streamId) => `${API_BASE_URL}/cctv/stream/${streamId}/index.m3u8`,
};
